import React, { ReactElement } from 'react';
import { useGetCustomerDataQuery } from '../../common/generated/graphql';
import { Container } from '@material-ui/core';
import Progress from '../../common/components/progress/progress';
import NetworkError from '../../common/components/network-error/network-error';
import { logError } from '../../common/helpers/log-error';
import {
  USER_UNDER_VALIDATION,
  USER_CREATED,
  USER_VALIDATED,
} from '../../common/model/enterprise-user-status';
import { Redirect, useLocation } from 'react-router-dom';

export default function CustomerRedirect(): ReactElement {
  const location = useLocation();
  const { data, loading, error, refetch } = useGetCustomerDataQuery({
    notifyOnNetworkStatusChange: true,
    onError: (err) => logError(err, 'Error executing Get Customer Data query'),
  });

  if (loading) {
    return (
      <Container>
        <Progress />
      </Container>
    );
  }

  if (error || !data) {
    return (
      <Container>
        <NetworkError errorMsg='Ocorreu um erro ao tentar obter os seus dados' retry={refetch} />
      </Container>
    );
  }

  switch (data.customerData?.enterpriseUser?.status) {
    case USER_CREATED:
    case USER_UNDER_VALIDATION:
      return <Redirect to={{ pathname: '/validate-code', search: location.search }} />;

    case USER_VALIDATED:
      return <Redirect to={{ pathname: '/validation-success', search: location.search }} />;

    default:
      return <Redirect to={{ pathname: '/email-input', search: location.search }} />;
  }
}
